import ChangeAddressModal from 'components/ChangeAddressModal';
import SingleAddressTile from 'components/SingleAddressTile';
import React, { useState } from 'react';
import styles from './index.module.scss';

const CartAddress = (props) => {
  const {
    user: { objectId: userId = '' } = {},
    details: { selectedAddress = {}, status = '' } = {},
    quoteCartFn,
  } = props;
  const [changeAddressModalOpen, setChangeAddressModalOpen] = useState(false);

  const onChangeAddress = async (address) => {
    quoteCartFn({ selectedAddressId: address?.objectId });
  };

  const isAddressSelected = !!selectedAddress?.address;

  const getAddress = () => {
    if (isAddressSelected) {
      return <SingleAddressTile
        contactName={selectedAddress?.contactName} 
        contactPhone={selectedAddress?.contactPhone} 
        addressDetails={selectedAddress}
        showSelector={false}
      />; 
    } else {
      return <div>
        No Address is selected
      </div>;
    }
  };

  const getAddressSelector = () => {
    if(status !== 'ACTIVE') return null;
    return (
      <div className={styles['select-address']} onClick={()=>{
        setChangeAddressModalOpen(true);
      }}>{isAddressSelected ? 'Change' : 'Select'}</div>
    );
  };

  return (
    <>
      {changeAddressModalOpen && (
        <ChangeAddressModal
          userId={userId}
          subscriptionId={'subscriptionId'}
          toggleModal={() => setChangeAddressModalOpen(!changeAddressModalOpen)}
          title="Change sales channel address"
          onAddressChange={onChangeAddress}
        />
      )}
      {getAddress()}
      {getAddressSelector()}
    </>
  );
};

export default CartAddress;

